module.exports = __webpack_public_path__ + "img/pay2.0b6b2a1e.png";